<template>
  <div class="sync-toast" role="status" aria-live="polite">
    <div class="pill" :class="toneClass" @click="expanded = !expanded">
      <span class="dot" />
      <strong >{{ state.title }}</strong>
      <span class="chev" aria-hidden="true">
        <i class="fas" :class="expanded ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
      </span>
    </div>

    <div v-if="expanded" class="panel" :class="toneClass">
      <p class="msg">{{ state.message }}</p>

      <ul class="details">
        <li>
          <span class="k">{{ $t('sync.details.connection') }}:</span>
          <span class="v">{{ onlineText }}</span>
        </li>

        <li>
          <span class="k">{{ $t('sync.details.unsynced_changes') }}:</span>
          <span class="v">{{ dirty ? $t('common.yes') : $t('common.no') }}</span>
        </li>

      </ul>

      <div class="actions" v-if="state.action">
        <button class="button is-small" @click.stop="state.action.onClick">
          {{ state.action.label }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SyncToast',
  props: {
    state: { type: Object, required: true },
    dirty: { type: Boolean, default: false },
    hasLocalDraft: { type: Boolean, default: false },
    isOnline: { type: Boolean, default: true },
  },
  data: () => ({ expanded: false }),
  computed: {

    toneClass() {
      if (this.storageRelevant) {
        if (this.storage?.level === 'critical') return 'is-danger';
        if (this.storage?.level === 'low') return 'is-warning';
      }

      if (this.state.tone === 'success') return 'is-success';
      if (this.state.tone === 'warning') return 'is-warning';
      if (this.state.tone === 'info') return 'is-info';

      return 'is-light';
    },
    onlineText() {
      return this.isOnline ? this.$t('sync.online') : this.$t('sync.offline');
    }
  }
};
</script>
<style scoped>
.sync-toast {
  top: 42px;
  padding: 10px 0;
  position: sticky;
  z-index: 3;
  max-width: 50%;
}

.pill {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 8px 12px;
  border-radius: 999px;
  cursor: pointer;
  user-select: none;
}

.pill.is-success { background: rgba(72 199 142);; }
.pill.is-warning { background: rgba(255,221,87); }
.pill.is-info    { background: rgba(32,156,238,); }
.pill.is-light   { background: rgba(245,245,245); }

.dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: currentColor;
  opacity: 0.9;
}

.title { font-size: 0.95rem; }
.chev { margin-left: 6px; opacity: 0.7; }

.panel {
  margin-top: 8px;
  padding: 12px;
  border-radius: 8px;
  background: white;
  border: 1px solid rgba(0,0,0,.08);
}

.panel.is-warning { border-color: rgba(255,221,87,.6); }
.panel.is-success { border-color: rgba(72,199,116,.5); }
.panel.is-info    { border-color: rgba(32,156,238,.4); }

.msg { margin-bottom: 10px; }

.details {
  margin: 0;
  padding-left: 16px;
}
.details li { margin: 4px 0; }

.k { opacity: 0.7; margin-right: 6px; }
.actions { margin-top: 10px; }

.pill.is-danger { background: rgba(255, 56, 96); }
.panel.is-danger { border-color: rgba(255, 56, 96, .5); }
</style>
